import { Component } from 'react'
import { Container, Row, Col, Nav, NavItem, NavLink } from 'reactstrap'
import ManagePreferenceHOC from '../Material/ManagePreferenceHOC'
import withApolloClient from '../withApolloClient'
import IncidentListHeader from './IncidentsListHeader'
import IncidentList from './IncidentsList'
import IncidentActions from "./IncidentActions"
import './Incidents.css'


const tableHeaders = [
    { id: "id", name: "Date Added", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "data_progress", name: "Data Progress", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "title", name: "Incident Name", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "assignedTo", name: "Assigned To", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "car__id", name: "Car", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "car_vin", name: "Vin", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "incident_branch", name: "Incident Branch", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "dmvPlate", name: "DMV Plate", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "driver__id", name: "Driver", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "notificationDate", name: "Notification Date", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "incidentDate", name: "Incident Date", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "incidentTime", name: "Incident Time", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "status", name: "Status", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "incidentType", name: "Incident Type", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "source", name: "Source", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "responsibleParty", name: "Responsible Party", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "reportedBy", name: "Reported By", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "incidentState", name: "Incident State", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "location", name: "Location", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "carOnHold", name: "Car On Hold", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "ridesharePlatform", name: "Rideshare Platform", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "ridesharePeriod", name: "Rideshare Period", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "ridesharePeriodSource", name: "Rideshare Period Source", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "carTotaled", name: "Car Totaled", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "hasPoliceReport", name: "Police Report?", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "hasDashcamVideos", name: "Dashcam Videos?", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "hasOtherParties", name: "Other Parties?", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "hasLiabilityClaim", name: "Liability Claim?", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "hasSubroClaim", name: "Subro Claim?", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "isRecordOnly", name: "Is Record Only?", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
]

const INCIDENT_LISTING_TABS = [
    { id: "#assigned", name: "Assigned Incidents" },
    { id: "#all", name: "All Incidents" },
]
class IncidentListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-id"],
            filterValues: { isArchived: false },
            refetchIncidents: false,
            tab: "#assigned",
            renderedTabPanes: [],
        }
    }

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };

    toggleTab = (tabId) => {
        if (!this.state.renderedTabPanes.includes(tabId)) {
            this.setState({ renderedTabPanes: [...this.state.renderedTabPanes, tabId] })
        }
        const selectedTab = INCIDENT_LISTING_TABS.find(tab => tab.id === tabId)
        const defaultFilters = { isArchived: false, ...(selectedTab?.filters || {}) }
        this.setState({
            tab: tabId,
            filterValues: defaultFilters
        })
    }

    componentDidMount() {
        let defaultTab = INCIDENT_LISTING_TABS[0].id
        if (window.location.hash && INCIDENT_LISTING_TABS.map(item => item.id).includes(window.location.hash)) {
            this.setState({ tab: window.location.hash, renderedTabPanes: [window.location.hash] })
        } else {
            window.location.hash = defaultTab
            this.setState({ tab: defaultTab, renderedTabPanes: [defaultTab] })
        }
    }
    componentDidUpdate(_, prevState) {
        if (this.state.tab !== prevState.tab) {
            window.location.hash = this.state.tab
        }
    }


    render() {
        return (
            <Container fluid className="bos-listing-container">
                <Nav tabs className="incident-list-tabs">
                    {INCIDENT_LISTING_TABS.map(item =>
                        <NavItem key={item.id}>
                            <NavLink className={this.state.tab === item.id ? "active" : "inactive"} onClick={() => this.toggleTab(item.id)} href={"#"} >
                                {item.name}
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>
                <Row>
                    <Col xs={8}>
                        <IncidentListHeader
                            filterValues={this.state.filterValues}
                            setFilterValues={(filterValues) => this.setState({ filterValues })}
                            defaultFilters={this.state.filterValues}
                            activeTab={this.state.tab}
                            {...this.props}
                        />
                    </Col>
                    <Col xs={4}>
                        <IncidentActions
                            columnConfig={this.props.columnConfig}
                            currentUser={this.props.currentUser}
                            refetchPreferences={this.props.refetchPreferences}
                            refetchQuery={() => this.setState({ refetchIncidents: !this.state.refetchIncidents })}
                            {...this.props}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <IncidentList
                            columnConfig={this.props.columnConfig}
                            key={String(this.state.refetchIncidents)}
                            currentUser={this.props.currentUser}
                            assignedTo={this.state.filterValues.assignedTo ? this.state.filterValues.assignedTo : this.state.tab === "#assigned" ? this.props.currentUser?.id : []}
                            searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                            driverPk={this.state.filterValues && this.state.filterValues.driverPk ? parseInt(this.state.filterValues.driverPk) : null}
                            incidentTypes={this.state.filterValues && this.state.filterValues.incidentTypes ? this.state.filterValues.incidentTypes : null}
                            incidentDateIsNull={this.state.filterValues && this.state.filterValues.incidentDateIsNull !== undefined ? this.state.filterValues.incidentDateIsNull : null}
                            withoutRental={this.state.filterValues && this.state.filterValues.withoutRental !== undefined ? this.state.filterValues.withoutRental : null}
                            isArchived={this.state.filterValues && this.state.filterValues.isArchived !== undefined ? this.state.filterValues.isArchived : null}
                            statuses={this.state.filterValues && this.state.filterValues.statuses ? this.state.filterValues.statuses : null}
                            carOnHold={this.state.filterValues && this.state.filterValues.carOnHold !== undefined ? this.state.filterValues.carOnHold : null}
                            carTotaled={this.state.filterValues && this.state.filterValues.carTotaled ? this.state.filterValues.carTotaled : null}
                            sources={this.state.filterValues && this.state.filterValues.sources ? this.state.filterValues.sources : null}
                            reportedBy={this.state.filterValues && this.state.filterValues.reportedBy ? this.state.filterValues.reportedBy : null}
                            responsibleParties={this.state.filterValues && this.state.filterValues.responsibleParties ? this.state.filterValues.responsibleParties : null}
                            ridesharePlatforms={this.state.filterValues && this.state.filterValues.ridesharePlatforms ? this.state.filterValues.ridesharePlatforms : null}
                            ridesharePeriods={this.state.filterValues && this.state.filterValues.ridesharePeriods ? this.state.filterValues.ridesharePeriods : null}
                            ridesharePeriodSources={this.state.filterValues && this.state.filterValues.ridesharePeriodSources ? this.state.filterValues.ridesharePeriodSources : null}
                            hasLiabilityClaim={this.state.filterValues && this.state.filterValues.hasLiabilityClaim !== undefined ? this.state.filterValues.hasLiabilityClaim : null}
                            hasSubroClaim={this.state.filterValues && this.state.filterValues.hasSubroClaim !== undefined ? this.state.filterValues.hasSubroClaim : null}
                            incidentBranchIds={this.state.filterValues?.incidentBranchIds ? this.state.filterValues.incidentBranchIds : null}
                            incidentDate={this.state.filterValues?.incidentDate ? this.state.filterValues.incidentDate : null}
                            orderBy={this.state.orderBy}
                            updateOrder={this.updateOrder}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}



export default withApolloClient(
    ManagePreferenceHOC("incident", tableHeaders)
        (IncidentListContainer)
)
